module.exports = __webpack_public_path__ + "img/tax_c.fe51cf7a.png";